import React, { useEffect, useState } from 'react'
import { Modal, Tabs } from 'antd'
import closeIcon from 'assets/Images/close.svg'
import './styles/styles.scss'
import DefalutActivityTab from './DefalutActivityTab'
import SpecificActivtyTab from './SpecificActivtyTab'
import AddActivity from '../Modals/addActivity/AddActivity'
import { Step4CurriculumPayload } from 'types/Classes/Classes'
import { classesEventStore } from 'state/classes/classesStore'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { CellClickEventArgs } from '@syncfusion/ej2-react-schedule'
import moment from 'moment'
import { convertTimeToUtcMinutes, calculateTimeDiffernce } from 'helper/utility'
import { convertDateToUtc } from '../../../utility'
import { infoMessage } from 'api/global'
import { defaultActivitiesResp, GetActivitiesTypes } from 'types/event/events'
import { useCreateUpdateActivityMutation } from 'api/Classes/Step4Schedule/Activites'

interface EventArgs extends CellClickEventArgs {
  Id?: string
  StartTime?: Date
  EndTime?: Date
}

interface SelectActivityProps {
  modalOpen: boolean
  setmodalopen: React.Dispatch<React.SetStateAction<boolean>>
  defaultData?: EventArgs
}

const SelectActivityModal: React.FC<SelectActivityProps> = ({
  modalOpen,
  setmodalopen,
  defaultData,
}) => {
  const classesData = classesEventStore(store => store.classesData)
  const activity = classesEventStore(store => store.activity)
  const setActivity = classesEventStore(store => store.setActivity)
  const setCustomActivity = classesEventStore(store => store.setCustomActivity)
  const setClassesData = classesEventStore(store => store.setClassesData)
  const [addActivityModal, setAddActivityModal] = useState<boolean>(false)
  const [params, setParams] = useState<GetActivitiesTypes>({
    organizationId: classesData.organizationId,
    defaultActivities: true,
  })
  const [selectedActivity, setSelectedActivity] =
    useState<defaultActivitiesResp>()
  const handleCancel = () => {
    setmodalopen(false)
  }
  const { mutate: createUpdateActivity, isLoading: createUpdateActivityLoading } =
    useCreateUpdateActivityMutation()

  const handleCreateNewActivity = () => {
    setCustomActivity(null)
    setAddActivityModal(true)
  }

  const handleAddActivity = () => {
    if (!selectedActivity) {
      return infoMessage('Please select an activity')
    }
    const payload: Step4CurriculumPayload = {
      isDefault: params.defaultActivities,
      curriculum: {
        duration: activity.difference,
        days: [activity.date],
        activityId: selectedActivity._id,
        tasks: [],
        supplies: [],
      },
    }
    createUpdateActivity(
      { body: payload, classId: classesData._id },
      {
        onSuccess: data => {
          setClassesData({ ...classesData, ...data })
          setSelectedActivity(undefined)
          handleCancel()
        },
      },
    )
  }

  const onChange = (key: string) => {
    if (key === '1') {
      setParams({ ...params, defaultActivities: true })
    } else {
      setParams({ ...params, defaultActivities: false })
    }
  }
  const items = [
    {
      key: '1',
      label: 'Default',
      children: (
        <DefalutActivityTab
          closeModal={setmodalopen}
          params={params}
          selected={selectedActivity}
          setSelected={setSelectedActivity}
        />
      ),
    },
    {
      key: '2',
      label: 'Specific',
      children: (
        <SpecificActivtyTab
          closeModal={setmodalopen}
          params={params}
          selected={selectedActivity}
          setSelected={setSelectedActivity}
        />
      ),
    },
  ]

  useEffect(() => {
    if (defaultData) {
      setActivity({
        ...activity,
        date: convertDateToUtc(defaultData.StartTime),
        startTime: convertTimeToUtcMinutes(
          moment(defaultData.StartTime).format('hh:mm a'),
        ),
        endTime: convertTimeToUtcMinutes(
          moment(defaultData.EndTime).format('hh:mm a'),
        ),
        difference: calculateTimeDiffernce(
          defaultData.StartTime,
          defaultData.EndTime,
          'minutes',
        ),
      })
    }
  }, [defaultData])

  return (
    <>
      <div>
        <Modal
          open={modalOpen}
          onCancel={handleCancel}
          className="select-activityModal"
          footer={false}
        >
          <div className="flex-center pt-20px justify-between ">
            <h2 className="w-600 text-18">Select activity</h2>
            <img
              src={closeIcon}
              alt="close-button"
              onClick={handleCancel}
              className="close button pointer"
            />
          </div>
          <div className="mt-10px text-center activity-select-container">
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
          </div>

          <div className="mt-30px flex align-center justify-between">
            <button
              className="create-activity-btn"
              onClick={handleCreateNewActivity}
            >
              Create new activity
            </button>
            <button className="confirm-btn" onClick={handleAddActivity}>
              {createUpdateActivityLoading ? (
                <ButtonSpinner size={20} color="#000" />
              ) : (
                'Confirm'
              )}
            </button>
          </div>
        </Modal>
      </div>
      <AddActivity
        modalOpen={addActivityModal}
        setModalOpen={setAddActivityModal}
      />
    </>
  )
}

export default SelectActivityModal
